import request from "@/plugins/pnsApi";

// 创建/修改自定义风格
async function createOrModifyCustomStyle(data) {
  let {
    diyName,
    styleJson,
    isActive = true,
    jsonName,
    coune = 1,
    pathNavigationSwitchPageId = 0,
  } = data;
  await request.post("/api/PathNavigationSwitch/AddPathNavigationSwitch", {
    diyName,
    styleJson,
    isActive,
    jsonName,
    coune,
    pathNavigationSwitchPageId,
  });
}

// 获取自定义风格
async function getCustomStyle(diyName) {
  const res = await request.post(
    "/api/PathNavigationSwitch/PathNavigationSwitchPageList",
    diyName
  );
  if (!res.data.length) {
    return { id: 0, value: "" };
  }
  return {
    id: res.data[0].pathNavigationSwitchPageId,
    value: res.data[0].styleJson,
  };
}

// 字段改名兼容表：老字段名 -> 新字段名（哪个字段改过名就在这里补一行）
const SORT_FIELD_ALIAS = {
  // oldFieldKey: "newFieldKey",
};

// 收集字段定义里的所有字段名（兼容 key / sortName / prop 与多级表头 children）
function collectFieldNames(list, names) {
  if (!Array.isArray(list)) return names;
  list.forEach((item) => {
    if (!item) return;
    [item.key, item.sortName, item.prop].forEach((val) => {
      if (val && names.indexOf(val) === -1) names.push(val);
    });
    if (Array.isArray(item.children)) {
      collectFieldNames(item.children, names);
    }
  });
  return names;
}

// 收集“当前列表真实存在的可排序字段名”
// 1. 列表组件上的 pOriginalData：代码里 import 的本地默认字段定义，最权威、不会过期
// 2. 当前已经渲染出来的 tableSort 组件上的 sortName：兜底
function getValidSortFields(vm) {
  const names = [];
  const walk = (comp, depth) => {
    if (!comp || depth > 12) return;
    const options = comp.$options || {};
    if (Array.isArray(comp.pOriginalData)) {
      collectFieldNames(comp.pOriginalData, names);
    }
    if (options.name === "tableSort" && comp.sortName) {
      if (names.indexOf(comp.sortName) === -1) names.push(comp.sortName);
      const last = String(comp.sortName).split(".").pop();
      if (last !== comp.sortName && names.indexOf(last) === -1) {
        names.push(last);
      }
    }
    (comp.$children || []).forEach((child) => walk(child, depth + 1));
  };
  walk(vm, 0);
  return names;
}

// 用当前列表字段校验保存的排序：改名的改过来、列表里已不存在的丢掉、同字段只留一条
function fixTableSort(list, vm) {
  if (!Array.isArray(list) || !list.length) return list;
  const valid = getValidSortFields(vm);
  // 扫不到本地字段定义就不动，保持原逻辑
  if (!valid.length) return list;
  const fixed = [];
  list.forEach((item) => {
    if (!item || !item.fieldName) return;
    let field = item.fieldName;
    if (valid.indexOf(field) === -1) {
      const last = String(field).split(".").pop();
      if (valid.indexOf(last) > -1) {
        field = last;
      } else if (
        SORT_FIELD_ALIAS[field] &&
        valid.indexOf(SORT_FIELD_ALIAS[field]) > -1
      ) {
        field = SORT_FIELD_ALIAS[field];
      } else {
        // 本地列表已经没有这个字段，丢弃
        return;
      }
    }
    // 同一个字段只保留一条
    if (fixed.some((it) => it.fieldName === field)) return;
    fixed.push({ ...item, fieldName: field });
  });
  return fixed;
}

// 获取表格排序
async function getTableSort(vm, name) {
  const eventName =
    name || localStorage.getItem("server") + vm.$options.name + "TableSort";
  const temp = await getCustomStyle(eventName);
  vm[eventName + "Id"] = temp.id;
  if (!temp.value) return;

  const raw = JSON.parse(temp.value);
  // 与当前列表字段对齐
  const result = fixTableSort(raw, vm);
  vm.tableSortBy = result;
  vm.$eventBus.$emit(eventName, result);

  // 存的是旧字段名，顺手把脏配置修正回服务端（只发生一次）
  if (JSON.stringify(result) !== JSON.stringify(raw)) {
    modifyTableSortBy(vm, result, name).catch(() => {});
  }
}

// 修改表格排序
async function modifyTableSortBy(vm, val, name) {
  const eventName =
    name || localStorage.getItem("server") + vm.$options.name + "TableSort";
  // 写侧也过滤，数组不会再无限增长
  const fixed = fixTableSort(val, vm);
  await createOrModifyCustomStyle({
    diyName: eventName,
    styleJson: JSON.stringify(fixed),
    pathNavigationSwitchPageId: vm[eventName + "Id"],
  });
  vm.tableSortBy = fixed;
  vm.$eventBus.$emit(eventName, fixed);
  if (!vm[eventName + "Id"]) {
    const temp = await getCustomStyle(eventName);
    vm[eventName + "Id"] = temp.id;
  }
}

export {
  createOrModifyCustomStyle,
  getCustomStyle,
  getTableSort,
  modifyTableSortBy,
};
